import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgbCollapseModule, NgbModalModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { ToastrModule } from "ngx-toastr";
import { PipesModule } from "src/app/theme/pipes/pipes.module";
import { RunTaskFilterComponentModule } from "../run-task-filter/run-task-filter.component.module";
import { RunTaskSearchComponent } from "./run-task-search.component";

@NgModule({
  imports: [
    CommonModule,
    NgxDatatableModule,
    NgbCollapseModule,
    NgbModalModule,
    RunTaskFilterComponentModule,
    ToastrModule,
    PipesModule
  ],
  declarations: [
    RunTaskSearchComponent
  ],
  exports: [
    RunTaskSearchComponent
  ]
})
export class RunTaskSearchComponentModule { }
